module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("BLUE STOPPED")]), _vm._v(" by Mom’s house to see if she wanted some help with her garden. He hadn’t seen her in weeks, not since it had snowed last and he’d shoveled her driveway and sidewalk for twenty bucks. That evening she’d insisted he spend the night on the couch.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“That place is too fuckin’ cold for you without electricity.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“It’s not so bad,” Blue had argued. “The next-door neighbors went to Florida for two months, and we hooked up a couple of those big orange power cords to their outdoor outlet.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She’d furrowed her brows at him. “Who paid for those power cords? Those things are pretty frigging expensive.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Sly got them cheap at a garage sale last year,” he’d explained.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You sure one of ya didn’t steal them?” She was leaning forward then, the blanket she’d been crocheting for the last hundred years or so in her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Blue had laughed at that. “Wouldn’t stealing those huge things be kinda hard?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She lifted a brow and then leaned back on her couch. “I guess if you don’t have a dress. I put a lot of things up my dress in bad times. I put a frozen goose in there once for Christmas dinner. I got frostbite between my thighs.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Blue had looked at her agog and exploded into laughter so hard he’d almost peed his pants. In fact, he did a little bit. But just a squirt.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She’d rolled them a rockin’ jay then. She grew marijuana in her backyard, behind her biggest flowers and shrubs. She kept the plants tight and trimmed and hidden, and it was good shit. A product of keeping them so small, all the THC—sticky and quite lovely—gathered heavy in the big buds. She didn’t sell it and shared it only with those she cared about. She grew it for her fibromyalgia, claimed that was the only reason, and while Blue believed the first part, he doubted the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Mom rolled a joint like a champ, and it took them an hour to finish it, because if they had smoked it any faster, it would have put him in a coma—it was that good. Another reason he didn’t go home, even though it was only a few blocks away. He was too fucked up to move.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You might not have stolen those cords,” she said and took a hit. “But you are stealing electricity.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“At least we won’t get frostbite on our thighs,” he shot back.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She nodded. “Touché,” she said in that way someone does when they’re holding in a hit, and then she blew out a cloud of smoke so big it reminded Blue of one of the dragons from "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Game of Thrones")]), _vm._v(". That image had sent him into new peals of laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("But today he saw there really wasn’t any gardening to do. It was still early in the year, and right now all that was growing were daffodils, hyacinth, the beginnings of tulips, and the end of the crocuses. There were hardly any weeds yet. But the leaves needed raking. She left them where they fell in the fall for mulch, but now seemed to be the time to get rid of them.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Besides, Mom hadn’t met Chewie.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Her tulips were the reason they’d met in the first place. He’d been walking down the sidewalk, hands deep in his back pockets, and quite suddenly they’d hit him with their blazing colors, and he’d stopped in his tracks. He learned later they were called parrot tulips, but all he knew that day was that they were gorgeous. Each petal was ruffled and rippled, and there were so many wonderful colors. He’d been delighted.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Like a child being led by the tune from the Pied Piper’s flute, he followed them up the driveway, around the side of the house, and out back—which was actually surrounded by a white picket fence—and he saw a yard full of daffodils of every shape, size, color, and description (and more tulips), and he simply couldn’t stop what he did next. He opened the gate, walked through, and, laughing, kicked off his shoes, pulled off his socks, and went tiptoeing—dancing—through the tulips. Laughing! He couldn’t stop. He was reaching to pick one, knowing he shouldn’t, when her voice rang out loud and clear—")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“What the "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("fuck")]), _vm._v(" are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("—and yes, he had peed his pants (a little).")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He had frozen in place, and his eyes had flown wide. His mouth had fallen open, but "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("nothing")]), _vm._v(" came out.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("On a very small back porch was a woman, probably about seventy years old, with a wild mane of "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("very")]), _vm._v(" curly black-and-gray hair, standing with her hands on her slim hips, a blazing fire in her dark eyes. Eyes that could turn people into stone. Maybe that’s why he couldn’t move. Medusa’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Put your right foot down.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("But he couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Well, are you just going to stand there like a "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("frigging")]), _vm._v(" lawn flamingo, or are you going to answer my "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("god")]), _vm._v("damned "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("question")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Somehow he was finally able to put his foot on the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And then? “I am "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("soooooo")]), _vm._v(" sorry,” he managed. “I knew I shouldn’t have. I knew it! But they were so pretty. I mean… so "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("gorgeous")]), _vm._v(". The petals. They… they look like feathers, and there are so many colors!” He’d looked down at them—cataloging. “Orange and red and yellow and green and pink and white and lavender and black and burgundy, and I’ve never seen anything like them, and suddenly I just started thinking about that song my mom used to play on her little record player, the one about tiptoeing through the tulips, and I took my shoes and socksoffandjumpedrightinthere—”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Whoa!” the woman shouted and made the time-out symbol. “Jesus H. Christ on a Popsicle stick!” She shook her head, then motioned to him. “Come here, kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Somehow she had unfrozen him as easily as she had frozen him in the first place. His face blazed hot with embarrassment.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Come "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("here")]), _vm._v(",” she said again and pointed at one of the rattan chairs on that itty-bitty back porch.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("When Blue didn’t move, her brows came together again, a big furrow, and his heart jumped. Then she shrugged and said, “Suit yourself,” and sat down herself, quite elegantly, like a queen on her throne.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("A moment later he went to her and folded himself lotus style into the second chair. His was painted a dark teal, and hers was more of a deep blue.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You smoke?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He smiled. “I’m proud to say that I’ve never had a single puff of a cigarette in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Well, good for you.” She nodded. “I mean that. It’s a nasty fricking habit. But I wasn’t talking about tobacco.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Oh!” His smile turned into a tremendous grin. “"), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Girl")]), _vm._v("! Now "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("that")]), _vm._v(" I smoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Somehow I thought a little bleached blond like you would,” she said, staring out at her tulips and drawing out a perfect joint from her blouse pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Blue’s mouth fell open. “I-I don’t b-bleach my hair!”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I-I d-don’t b-b-bleach m-my hair,” she mocked.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("The mockery hurt for about a second, and then he saw the bemused look on her face. She was teasing him.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Honey.” She pointed at his head. “That color doesn’t come in nature except on albinos and very old people. And your roots are dark blond.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("While she lit the joint with a lighter that seemed to have appeared in her hand by magic, Blue’s eyes went wide in horror. He reached for his scalp, pressed and dug as if his fingertips had eyes and could see the blasphemy of a hair color gone bad.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Relax,” she said, blowing out an incredible cloud of smoke and handing him the joint.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Blue took the jay and hit it, and the pot went down smooth and fine as a shot of frigid cold Patrón, but when he released it, he started coughing, hard, and blushed that the old woman could take her smoke so much better than him.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She eyed him, a twinkle in her eyes, and retrieved the joint. She shrugged. “You don’t get off until you cough,” she said. “Or so I’ve heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He could only stare. Who "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("was")]), _vm._v(" this woman?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Now me?” She shrugged again. “"), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("I")]), _vm._v(" have adamantine lungs.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("When he didn’t say anything, she said, “Adamantine means—”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Rigidly firm,” he supplied. “Unyielding. Resembling a diamond in hardness or luster.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She looked at him in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“It was the metal used by the gods to chain Prometheus to the rocks for stealing fire from heaven. It was also the inspiration for adamantium, the fictional metal that was used to make Wolverine’s skeleton and claws and—”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She held up her hand—"), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Halt!")]), _vm._v("—and when he halted, she passed the joint. “You’re an interesting cookie.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Really?” For some reason that made him quite happy. This lady was fascinating, and for her to say that "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("he")]), _vm._v(" was interesting was pretty fripping cool.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("They sat quietly, passing the jay, neither talking. Blue wanted to say something. God, he wanted to. But he was afraid if he did he wouldn’t be able to stop, caught up in one of his avalanches of words, his diarrhea of the mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("But then the joint was way too small for him to keep passing. He couldn’t believe how long she nursed it, down to a mind-bogglingly miniscule snippet of paper and marijuana. It wasn’t even like she had long nails! Were her fingers made of asbestos?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She finally broke the silence. “Okay, what saved you in "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("my")]), _vm._v(" book was the tiptoeing. You really like my flowers. And you were being careful. Even if you were about to pick one.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Oh yes!” he cried, sitting up and then almost falling forward from the effect of the pot.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“What would you think of helping me out around here?” She waved an arm expansively in the direction of—well, "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("everything")]), _vm._v(". “Mowing my front yard. It’s a small one. I only have an old-fashioned push mower. Never needed more. I’d need you to do some weeding, planting bulbs and annuals in the spring and bulbs in the fall. Raking. Mulching. I just can’t keep up with it anymore. I’ll pay you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("His eyes flew wide. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Pay me?")]), _vm._v(" To do something fun? “"), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Sure")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("That’s how it began.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Somewhere along the line, he started calling her Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You know I’m old enough to be your "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("grand")]), _vm._v("mother, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Yes. He knew that. But the last thing he wanted to do was think of her as his grandmother. The "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("very")]), _vm._v(" last thing.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Mom was better.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And after a while, he even started pretending she was his mom. He even told people he had a mom.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("It was nice.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Today he wanted to see her. But when he knocked on the door, there was no answer, and he went to the rickety old garage and peeked in through the little windows. Her car wasn’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Where could she be?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He called her, and she answered on the third ring. “Blue, whaddya want?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I’m sitting on my chair,” he said. The teal one. He had one foot on the ground and the other over his knee, and then habit took over and the other foot came up to join the first. “Wondering where you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Outta town, sugar dumpling.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Where?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Wouldn’t "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("you")]), _vm._v(" like to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("It stung.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Branson, hon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Branson?")]), _vm._v(" Mom was in Branson? “"), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Branson")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“What can I say? I got invited. Harry invited me. There are massages. Hot stones. Pedicures even.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Pedicures?” He stuck out a lip.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Stop pouting.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She knew. How did she always know?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I got a dog,” he replied, hoping to surprise her.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You did?” He couldn’t tell if he’d gotten her or not.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“A labradoodle. I named him Chewie.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Like the Wookiee?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He nodded. Funny that people did that when they were on the phone and the other person couldn’t see.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Hearing his name, Chewie came over and laid his shaggy head in Blue’s lap. Blue smiled. How could he help it? What with those big brown eyes looking up at him. He scratched behind Chewie’s ears.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And oh, the depth of those eyes….")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Do you have any dog food? "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Good")]), _vm._v(" dog food?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("No.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Look under the fern pot. There’s fifty bucks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Fifty bucks?")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I want you to go to Four-Footed Friends and get him something good.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Those big brown eyes!")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“And you know where the key is. There is some leftover lasagna in the refrigerator that’ll make you cum in your pants.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Blue burst into laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Kidness? I gotta go. The hot rocks are calling.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He sighed. “Okay, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I’ll be home in a day or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Okay, Mom,” he said again and laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Okay, then. Later ’gator.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“While ’dile.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("They hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And he tried to be happy for her.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He was just so fucking lonely.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98627728","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0006.vue
// module id = 72
// module chunks = 0